<template>
  <div class="embedded-image">
    <span v-if="debug" @click="reload">reload</span>
    <img v-if="asset_url" :src="asset_url" @error="onImageError"
      @load="$extension.window.updateHeight()" />

    <br /><br />

    <div v-if="!error_msg" class="help">
      {{ help_text }}
    </div>

    <div v-else class="error" @click="fetchAndSaveAssetURL">
      {{ error_msg }}
    </div>
  </div>
</template>

<script>
import FieldMixin from '../Field.mixin.vue';

export default {
  mixins: [FieldMixin],
  props: {
  },
  data () {
    return {
      params: {},
      error_msg: '',
      cache_for: 12 * 60 * 60 * 1000
    };
  },
  methods: {
    onImageError () {
      this.error_msg = 'The image failed to load.';
    },
    reload () {
      location.reload();
    },
    loadDataFromContentful () {
      const params = this.$extension.field.getValue();

      // console.log('contentful value', params);
      // return false;
      if (params) {
        console.log('found contentful data');
        this.params = params;

        if (!this.params.updated) return false;
        if (!this.params.asset_id || this.params.asset_id !== this.asset_id) return false;

        const updated = new Date(this.params.updated);
        const now = new Date();

        // store a timed cache of asset URL, so we're not hitting the API a bunch
        if (now - updated > this.cache_for) {
          return false;
        }
        else {
          return true;
        }
      }
      else {
        console.warn('no configuration found for key value field');
        return false;
      }
    },
    async fetchAndSaveAssetURL () {
      let asset;

      console.log('refetching asset URL');

      try {
        asset = await this.$extension.space.getAsset(this.asset_id);
      }
      catch (err) {
        console.error('could not get asset ID');
        console.error(err);
        return;
      }

      await this.saveDataToContentful({
        asset_url: asset.fields.file['en-US'].url,
        asset_id: this.asset_id,
        updated: (new Date()).toISOString()
      });

      this.loadDataFromContentful();
    }
  },
  computed: {
    asset_id () {
      return this.$extension.parameters.instance.asset_id.trim();
    },
    asset_url () {
      return this.params.asset_url ? this.params.asset_url : '';
    },
    help_text () {
      return this.$extension.parameters.instance.help.trim();
    }
  },
  watch: {
  },
  created () {
    const data_ok = this.loadDataFromContentful();
    console.log(data_ok);
    if (!data_ok) {
      this.fetchAndSaveAssetURL();
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}

.help {
  font-style: italic;
  color: gray;
  font-size: 14px;
}

.embedded-image {
  user-select: none;
  overflow: hidden;
}

.error {
  color: #fb5454;
}
</style>
